export default "__VITE_ASSET__JP$qQGQk__"